import React from "react";
import { Route } from "react-router-dom";
import { getQueryParams, getQueryString } from "../../../helpers/common";
import { getSideMenuList, getSideMenuListEnd } from "../../../routes/menus";
import MenuItem from "./MenuItem";

const RouteWithSubMenu = ({ component: Component, visible, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <div className={`leftsideNav animate ${visible ? "show" : "hide"}`}>
        <Component {...props} />
      </div>
    )}
  />
);

const LeftSideMenuList = (props) => {
  const menus = getSideMenuList();
  const bottomMenus = getSideMenuListEnd();
  const matchUrl = props.match.url;
  const query = getQueryParams(props.location.search);
  const isSubMenu = !(parseInt(query.sub) === 0);

  const getActive = (name) => {
    if (!name) return false;
    const paths = window.location.pathname.toLowerCase().split("/");
    return paths.indexOf(name.toLowerCase()) >= 0 && paths.indexOf("map") >= 0;
  };

  const getSearchString = (item, isSubMenu) => {
    return getActive(item.name)
      ? getQueryString({ sub: isSubMenu ? 0 : 1 })
      : getQueryString({ sub: 1 });
  };

  return (
    <div>
      <div className="mobile-h-100 side_navbar_container">
        <ul className="sidebar navbar-nav top-menu-items toggled">
          {menus.map((item, i) => {
            const to = item.path
              ? {
                pathname: `${matchUrl}${item.path}`,
                search: getSearchString(item, isSubMenu),
              }
              : null;

            const props = { ...item, to };
            return item.children ? (
              <MenuItem key={i} {...props}>
                <item.children />
              </MenuItem>
            ) : (
              <MenuItem key={i} {...props} />
            );
          }, this)}
        </ul>

        {menus.map((item, i) => {
          if (!item.component) return "";
          const path = `${props.match.path}/map/${item.name}`;
          return (
            <RouteWithSubMenu
              key={i}
              path={path}
              visible={isSubMenu}
              component={item.component}
            />
          );
        })}

        <ul className="sidebar navbar-nav bottom-menu-items toggled">
          {bottomMenus.map((item, i) => {
            const to = item.path
              ? {
                pathname: `${matchUrl}${item.path}`,
                search: getSearchString(item, isSubMenu),
              }
              : null;

            const props = { ...item, to };
            return item.children ? (
              <MenuItem key={i} {...props}>
                <item.children />
              </MenuItem>
            ) : (
              <MenuItem key={i} {...props} />
            );
          }, this)}
        </ul>

        {bottomMenus.map((item, i) => {
          if (!item.component) return "";
          const path = `${props.match.path}/map/${item.name}`;
          return (
            <RouteWithSubMenu
              key={i}
              path={path}
              visible={isSubMenu}
              component={item.component}
            />
          );
        })}
      </div>
    </div>
  );
};

export default LeftSideMenuList;
